export const LOAD_CONTENT = 'mp/cancel/LOAD_CONTENT';

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/MyPlan/cancel/cancel.js
 **/